// Centralized GA4 tracking utility
// Uses gtag.js loaded via index.html script tag

interface EventParams {
  [key: string]: string | number | boolean | undefined;
}

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || "G-BNP2V0FJXJ";

export const analytics = {
  /** Track a page view. Call on every route change. */
  pageView(path: string, title?: string) {
    if (typeof window.gtag === 'undefined') return;
    window.gtag('event', 'page_view', {
      page_path: path,
      page_title: title || document.title,
    });
  },

  /** Fire a custom GA4 event. */
  event(eventName: string, params?: EventParams) {
    if (typeof window.gtag === 'undefined') return;
    window.gtag('event', eventName, params);
  },

  /** Associate subsequent events with a known user (on login / session restore). */
  setUser(userId: string, properties?: EventParams) {
    if (typeof window.gtag === 'undefined') return;
    const measurementId = GA_MEASUREMENT_ID;
    if (!measurementId) return;
    window.gtag('config', measurementId, {
      user_id: userId,
      ...properties,
    });
  },

  /** Clear the associated user (on logout). */
  clearUser() {
    if (typeof window.gtag === 'undefined') return;
    const measurementId = GA_MEASUREMENT_ID;
    if (!measurementId) return;
    window.gtag('config', measurementId, {
      user_id: undefined,
    });
  },
};

// ---------------------------------------------------------------------------
// TypeScript global augmentation for gtag / dataLayer
// ---------------------------------------------------------------------------
declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtag?: (...args: any[]) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataLayer?: any[];
  }
}
